import Dot from '../src/Dot/index';
export default Dot;
